import cloneDeep from 'lodash/cloneDeep';
import transform from '@/services/devisCommandes/filters/devisCommandeServerTableDataTransformer';
import postGetCommandesList from '@/services/devisCommandes/postGetCommandesList';
import { getAllForDevisCommandeFactureAsync } from '@/api/commissionVendeur';
import { getLettragesWithFacturesForCommissions } from '@/api/lettrage';
import { TYPE_REFERENCE_EXTERNE_LETTRAGE_A_PAIEMENT } from '@/configuration/dcf/dcfConf';
import transformerCommissions from '@/services/commissions/transformerCommissions';
import genererCritereCommandeCommissions
  from '@/services/commande/commandeCommissions/genererCritereCommandeCommissions';
import * as types from './commande-mutation-type';
import * as allTypes from '../mutation-type';

function initialState() {
  return {
    commandes: [],
    lastDataFromLoad: {},
    totalCommandes: 0,
    criteresRecherche: cloneDeep(genererCritereCommandeCommissions()),
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_COMMANDES](state, commandes) {
    state.commandes = commandes;
  },
  [types.SET_TOTAL_COMMANDES](state, totalCommandes) {
    state.totalCommandes = totalCommandes;
  },
  [types.SET_COMMANDE_LASTDATAFROMLOAD](state, lastDataFromLoad) {
    state.lastDataFromLoad = lastDataFromLoad;
  },
  [types.SET_CRITERE_RECHERCHE](state, critere) {
    state.criteresRecherche = critere;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadCommandesAchat({ commit }, data) {
    transformerCommissions(data);
    commit(types.SET_COMMANDE_LASTDATAFROMLOAD, data);
    const response = await getAllForDevisCommandeFactureAsync(data);
    response.data.result.items.forEach(postGetCommandesList);
    let lettrage = [];
    const ids = [...new Set(response.data.result.items
      .filter((item) => {
        return item.typeReferenceExterne === TYPE_REFERENCE_EXTERNE_LETTRAGE_A_PAIEMENT
        && item.referenceExterne3Id;
      }).map((item) => item.referenceExterne3Id))];
    if (ids.length > 0) {
      lettrage = (await getLettragesWithFacturesForCommissions(ids)).data.result;
    }
    response.data.result.items
      .filter((commande) => {
        return commande.typeReferenceExterne === TYPE_REFERENCE_EXTERNE_LETTRAGE_A_PAIEMENT;
      })
      .forEach((commande) => {
        const lettrageFound = lettrage.find((l) => l.id === commande.referenceExterne3Id);
        if (lettrageFound) {
          commande.remiseBancaireId = lettrageFound.mouvementClient1
          && lettrageFound.mouvementClient1.remiseBancaireId
            ? lettrageFound.mouvementClient1.remiseBancaireId
            : lettrageFound.mouvementClient2.remiseBancaireId;
          commande.lettrage = lettrageFound;
        }
      });
    commit(types.SET_TOTAL_COMMANDES, response.data.result.totalCount);
    commit(types.SET_COMMANDES, response.data.result.items);
    return {};
  },
};

const getters = {
  commandes: state => {
    return state.commandes;
  },
  totalCommandes: state => {
    return state.totalCommandes;
  },
  lastDataFromLoad: state => {
    return transform(state.lastDataFromLoad);
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  totalCommandesBeforeNow: state => {
    return state.totalCommandesBeforeNow;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
